'use strict';

function soGoToLang(soTranslateSettings) {
    return function(label) {
        return soTranslateSettings.goToLanguage(label);
    }
};

soGoToLang.$inject = ['soTranslateSettings']
export default soGoToLang


// WEBPACK FOOTER //
// ./src/app/scripts/modules/soGoToLang.js